<template>
    <transition name="confirm-fade">
        <div v-if="isShowConfirm" class="my-confirm" @click.stop="clickFun('clickCancel')">
            <div :class="wrapCssName[styleType]" @click.stop>
                <h3 :class="['my-confirm-title',  titleType==1 ? 'my-confirm-success' : (titleType==2 ? 'my-confirm-error' : '')]"><i v-if="titleType>0"></i>{{ titleText }}</h3>
                <p class="my-confirm-content">{{ content }}</p>
                <div :class="btnCssName[styleType]">
                    <div v-if="type=='confirm'" class="my-cancel-btn my-border-right" @click="clickFun('clickCancel')">
                        <p class="my-btn-text">{{ cancelText }}</p>
                    </div>
                    <div class="confirm-btn" @click="clickFun('clickConfirm')">
                        <p class="my-btn-text">{{ confirmText }}</p>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script type="text/ecmascript-6">
    export default {
        data () {
            return {
                wrapCssName: ['confirm-content-wrap', 'confirm-content-wrap-guess'], //包裹样式名称
                btnCssName: ['my-operation', 'my-operation-guess'], //按钮样式名称
                isShowConfirm: false, // 用于控制整个窗口的显示/隐藏
                titleText: this.txtLang[this.langName]['confirmTitle'], // 提示框标题
                content: 'Say Something ...', // 提示框的内容
                cancelText: this.txtLang[this.langName]['confirmCancel'], // 取消按钮的文字
                confirmText: this.txtLang[this.langName]['confirmText'], // 确认按钮的文字
                type: 'confirm', // 表明弹框的类型：confirm - 确认弹窗（有取消按钮）；alert - 通知弹框（没有取消按钮）
                titleType: 0, //用于控制title是否带图标
                styleType: 0, //弹框样式 0-默认, 1-抽奖
                outerData: null // 用于记录外部传进来的数据，也可以给外部监听userBehavior，事件的函数提供判断到底是哪个事件触发的
            }
        },
        methods: {
            show (content, config) {
                this.content = content || 'Say Something ...';

                if (Object.prototype.toString.call(config) === '[object Object]') {
                    // 确保用户传递的是一个对象
                    this.titleText = config.titleText || this.txtLang[this.langName]['confirmTitle'];
                    this.cancelText = config.cancelText || this.txtLang[this.langName]['confirmCancel'];
                    this.confirmText = config.confirmText || this.txtLang[this.langName]['confirmText'];
                    this.type = config.type || 'confirm';
                    this.titleType = config.titleType || 0;
                    this.styleType = config.styleType || 0;
                    this.outerData = config.data || null;
                }

                this.isShowConfirm = true
            },
            hidden () {
                this.isShowConfirm = false;
                this.titleText = this.txtLang[this.langName]['confirmTitle'];
                this.cancelText = this.txtLang[this.langName]['confirmCancel'];
                this.confirmText = this.txtLang[this.langName]['confirmText'];
                this.type = 'confirm';
                this.titleType = 0;
                this.outerData = null
            },
            clickFun (type) {
                if(type == 'clickConfirm'){
                    if(typeof(this.outerData) == 'function'){
                        this.outerData();
                    }
                }
                //this.$emit('userBehavior', type, this.outerData);
                this.hidden();
            }
        }
    }
</script>

<style scoped>
    .my-confirm {position: fixed;top: 0;left: 0;right: 0;bottom: 0;background-color: rgba(0, 0, 0, 0.5);z-index: 998;
        /* 防止当用户长按屏幕，出现的黑色背景色块，以及 iPhone 横平时字体的缩放问题 */
        -webkit-text-size-adjust: 100%;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    /* 进入和出去的动画 */
    .confirm-fade-enter-active {animation: opacity 0.3s;}
    .confirm-fade-enter-active .confirm-content-wrap {animation: scale 0.3s;}
    .confirm-fade-leave-active {animation: outOpacity 0.2s;}

    /* 包裹层容器样式 */
    .confirm-content-wrap, .confirm-content-wrap-guess {position: absolute;top: 30%;left: 0;right: 0;width: 640px;margin: 0 auto;background-color: #232048;border-radius: 16px;z-index: 999;user-select: none;}
    .confirm-content-wrap-guess{background-color:#6770e6;}

    /* 顶部标题部分 */
    .my-confirm-title {padding-top: 50px;text-align: center;font-size: 36px;color: #fff;font-weight:bold;}
    .my-confirm-success{color:#00d9cd;}
    .my-confirm-error{color:#e74f6b;}
    .my-confirm-success i, .my-confirm-error i{display:inline-block;width:40px;height:40px;margin-right:20px;vertical-align:middle;}
    .my-confirm-success i{background:url(../../../static/image/success_i.png) no-repeat 0 0;background-size:100% auto;}
    .my-confirm-error i{background:url(../../../static/image/error_i.png) no-repeat 0 0;background-size:100% auto;}

    /* 中间内容部分 */
    .my-confirm-content {padding:20px 15px 50px;text-align: center;font-size: 30px;color: #fff;line-height: 1.5;}

    /* 底部按钮样式 */
    .my-operation, .my-operation-guess {display: flex;border-top: 2px solid #3b3860;}
    .my-operation-guess{border-top:2px solid #5861c7;}
    .my-cancel-btn, .confirm-btn {flex: 1;color:#65637f;}
    .confirm-btn {color: #fff;}
    .my-operation-guess .my-cancel-btn{color:#b2b8e3;}
    .my-btn-text {text-align: center;font-size: 36px;margin: 14px 0;padding: 6px 0;}

    /* 其他修饰样式 */
    .my-border-right {border-right: 2px solid #3b3860;}
    .my-operation-guess .my-border-right{border-right: 2px solid #5861c7;}

    /* 进来的动画 */
    @keyframes opacity {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    @keyframes scale {
        0% {
            transform: scale(0);
        }
        60% {
            transform: scale(1.1);
        }
        100% {
            transform: scale(1);
        }
    }

    /* 出去的动画 */
    @keyframes outOpacity {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/common/Confirm.vue